import { useEffect, useState } from 'react';
import type { StageSize } from '../../../types/canvas.types';

/**
 * Hook pour gérer la taille du stage en fonction de la taille de la fenêtre
 */
const useStageSize = (): StageSize => {
  const [stageSize, setStageSize] = useState<StageSize>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const updateStageSize = () => {
      if (window.innerWidth > 1024) {
        setStageSize({
          width: window.innerWidth - 400,
          height: window.innerHeight,
        });
      } else {
        setStageSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
    };

    updateStageSize();
    window.addEventListener('resize', updateStageSize);

    return () => {
      window.removeEventListener('resize', updateStageSize);
    };
  }, []);

  return stageSize;
};

export default useStageSize;
